import { ImageAcquisitionPage } from "../../image-acquisition/ImageAcquisitionPage"


export const Acquire = () => {
    return (
        <ImageAcquisitionPage />
    )
}